var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLaptop = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 17.25C24 16.8358 23.6642 16.5 23.25 16.5H0.75C0.335786 16.5 0 16.8358 0 17.25V18C0 19.6569 1.34315 21 3 21H21C22.6569 21 24 19.6569 24 18V17.25ZM22.5 18H1.5C1.5 18.8284 2.17157 19.5 3 19.5H21C21.8284 19.5 22.5 18.8284 22.5 18Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6 3C4.34315 3 3 4.34315 3 6V14.25C3 14.6642 3.33579 15 3.75 15V15C4.16421 15 4.5 14.6642 4.5 14.25V6C4.5 5.17157 5.17157 4.5 6 4.5H18C18.8284 4.5 19.5 5.17157 19.5 6V14.25C19.5 14.6642 19.8358 15 20.25 15V15C20.6642 15 21 14.6642 21 14.25V6C21 4.34315 19.6569 3 18 3H6Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLaptop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/laptop.2b32fe91d168ac8def3e039271ec8eba.svg";